var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	
$(document).ready(function() {
	$("#frmSupport").validate();

	if(siteId == 1){
		$(".phone").mask("(999) 999-9999");
	}else{
		$(".phone").mask("9999999999999999");
	}
	$("#gsm_code").intlTelInput({
// 				preferredCountries: ["${countryCode}"],
		preferredCountries: [CommonPayment.countryCode],
		americaMode: false
	});


	$("#gsm_code").focusout(function(){
		var isTR = $("[name=gsm_code]").val().includes("+90");
		if(isTR){
			$("[name=gsm]").mask("(999) 999-9999");
		}else{
			$("[name=gsm]").mask("999999999999999");
		}
	});

	$(".email").validate();
	$(".accordion-usage , .accordion-faq").accordion({
		autoHeight : false,
		collapsible : true,
		active : 52
	});
	$(".cc-chat").click(function() {
		try {
			LC_API.open_chat_window();
		} catch (e) {
			return false;
		}
		return false;
	});
	
});

function sendInfo(){
	var email = $("#email").val();
	var gsm = $("#gsm").val();
	var isEmailValid = emailValidation('email');
    $("#frmSupport").validate().cancelSubmit = false;
    $("#frmSupport").validate();
	if(!$("#frmSupport").valid()) return false;
	if(grecaptcha.getResponse().length == 0){
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return false;
	}
	if (!isEmailValid) {
		grecaptcha.reset();
		return false;
	}	
	if (email == "") {
		alert(FmtMessage.getMessage('js.invite.emptyEmail.warn'));
	}else{
		$("#frmSupport").submit();
	}
	grecaptcha.reset();
}

$("#frmSupport").submit(function(e) {
    e.preventDefault();
    $.ajax({
    	type:'POST',
        async:false,
        url: '/supportWithForm',

        data: $("#frmSupport").serialize(),
        success: function(data) {
        	$("#response").show();
        	if(data){
        		//$('#btnSupport').attr("disabled", true);
                resetSupportForm();
                $("#failure").hide();
        		$("#success").show();
                $('html, body').animate({scrollTop:$('.inner-page-title').offset().top}, 'slow');
                $("#frmSupport").validate().cancelSubmit = true;

        	}else{
        		$("#success").hide();	
        		$("#failure").show();
        	}
         },
        error: function() {
            //alert('Error occured');
        }
    });       
});

function resetSupportForm() {
    $("#frmSupport").val
	$("[name=supportType]").val("");
	$("[name=referenceNo]").val("");
	$("[name=name]").val("");
	$("[name=surname]").val("");
	$("[name=email]").val("");
	$("[name=gsm]").val("");
	$("[name=subject]").val("");
	$("[name=content]").val("");
}

function reloadCaptcha() {
	$('#captcha').attr('src', '/captcha?' + new Date().getTime());
}